import React from 'react';
import { DIMENSIONS } from '@air/shared';
import { T, fonts } from '../../theme/tokens';

export function SignalMeter({ c, animate = true }) {
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
      {DIMENSIONS.map((d) => {
        const s = c[d.key] || 0;
        const pct = Math.max(6, (s / 5) * 100);
        return (
          <div
            key={d.key}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 7,
            }}
          >
            <div
              style={{
                width: "100%",
                height: 96,
                borderRadius: 0,
                background: T.creamDark,
                display: "flex",
                alignItems: "flex-end",
                overflow: "hidden",
                border: `1px solid ${T.borderLight}`,
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: `${pct}%`,
                  background: T.accent,
                  transition: animate ? "height .8s cubic-bezier(.2,.8,.2,1)" : "none",
                }}
              />
            </div>
            <span style={{ fontFamily: fonts.body, fontSize: 11, fontWeight: 600, color: T.textMid }}>
              {s ? s.toFixed(1) : "–"}
            </span>
            <span
              style={{
                fontFamily: fonts.body,
                fontSize: 9,
                color: T.textLight,
                textAlign: "center",
                lineHeight: 1.2,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              {d.short}
            </span>
          </div>
        );
      })}
    </div>
  );
}
